import axios from 'axios'
import router from '../router';
import { Toast } from 'vant'
import Vue from 'vue'

const vm = new Vue()
// 创建axios实例
const service = axios.create({
    baseURL: vm.$config.API_BASE_URL,//'http://localhost:8802',
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json;charset=utf-8'
    }
})

// 存储loading实例
let loadingInstance = null

// request拦截器
service.interceptors.request.use(
    config => {
        // 显示loading（可配置是否显示）
        if (config.config.showLoading !== false) {
            loadingInstance = Toast.loading({
                message: config.loadingText ? config.loadingText : '加载中...',
                forbidClick: true,
                duration: 0,
                loadingType: 'spinner'
            })
        }

        // 在发送之前做些什么
        const token = localStorage.getItem('userToken');
        if (token) {
            config.headers['userToken'] = token;
        } else {
            config.headers['userToken'] = "weishouquan";
        }
        return config
    },
    error => {
        // 关闭loading
        if (loadingInstance) {
            loadingInstance.clear()
            loadingInstance = null
        }
        showError('请求配置错误', 'fail')
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        // 关闭loading
        if (loadingInstance) {
            loadingInstance.clear()
            loadingInstance = null
        }

        const res = response.data
        if (res.ErrorCode != 0 && res.ErrorCode != null) {
            // Token 过期了;
            if (res.ErrorCode == 301) {
                localStorage.removeItem("userToken");
                router.push('/login');
            } else {
                showError(res.ErrorMessage)
            }
            return Promise.reject(res);
        } else {
            return res.Data;
        }
    },
    error => {
        // 关闭loading
        if (loadingInstance) {
            loadingInstance.clear()
            loadingInstance = null
        }
        // 响应失败的时候
        showError('网络错误')
        return Promise.reject(error)
    }
)

export default function fetch(url, method, data, config) {
    return new Promise((resolve, reject) => {
        if (method === 'get' || method === 'GET') {
            service.get(url, {
                params: data
            })
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
        } else {
            service({
                method,
                url,
                data,
                config
            })
                .then(response => {
                    resolve(response)
                }, err => {
                    reject(err)
                })
        }
    })
}

// 显示错误提示
function showError(message, type = 'fail') {
    // 如果已经有Toast在显示，先清除
    Toast.clear()

    switch (type) {
        case 'dialog':
            Dialog.alert({
                title: '提示',
                message: message,
                theme: 'round-button',
                confirmButtonColor: '#ee0a24'
            })
            break
        case 'notify':
            Notify({
                type: 'danger',
                message: message,
                duration: 3000,
                background: '#ee0a24'
            })
            break
        case 'success':
            Toast.success({
                message: message,
                duration: 2000
            })
            break
        case 'fail':
        default:
            Toast.fail({
                message: message,
                duration: 3000
            })
    }
}